import React, { Fragment, useEffect, useState } from "react";

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/DeleteRounded";

import dayjs from "dayjs";

// components
import TablePagination from "../Table/TablePagination";
import IOSSwitch from "../../components/IOSSwitch";
import AppDialog from "./Dialog";
import { destroy, get, toggleIsTop } from "../../db";
import ToolTipButton from "../../components/ToolTipButton";
import { permissionError } from "../../util/alert";
import { useStateValue } from "../../store/provider";

const columns = [
  { label: "Sr.No" },
  { label: "Name" },
  { label: "Icon" },
  { label: "URL" },
  { label: "Category" },
  { label: "Is Top" },
  { label: "Created" },
  { label: "Action" },
];

const Category = () => {
  const [{ admin }] = useStateValue();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    get(setData, "apps");
    get(setCategories, "categories");
  }, [page, setData, setCategories]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDelete = (id) => {
    if (!admin.flag) return permissionError();
    destroy(id, "apps");
  };

  const handleIsTop = (id, flag) => {
    if (!admin.flag) return permissionError();
    toggleIsTop(id, flag, "apps");
  };

  return (
    <Grid container alignItems="center">
      <Grid item md={12}>
        <AppDialog />
        <TableContainer style={{ marginTop: 50 }} component={Paper}>
          <Table aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell key={index} align="center">
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length > 0 && categories.length > 0 ? (
                <Fragment>
                  {(rowsPerPage > 0
                    ? data.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : data
                  ).map((row, key) => {
                    const index = categories.findIndex(
                      (item) => item._id === row.category_id
                    );

                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                        <TableCell align="center">
                          <Typography variant="body1">{key + 1}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body1">
                            {row.name.length > 10
                              ? row.name.substr(0, 7) + "..."
                              : row.name}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={row.icon}
                            alt="icon"
                            style={{
                              maxWidth: 80,
                              maxHeight: 80,
                              borderRadius: 5,
                              objectFit: "cover",
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body1">
                            {row.url.length > 10
                              ? row.url.substr(0, 7) + "..."
                              : row.url}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body1">
                            {categories[index] ? categories[index].name : null}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <IOSSwitch
                            onClick={() => handleIsTop(row._id, row.top)}
                            checked={row.top}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body1">
                            {dayjs(row.createdAt).format("DD MMM, YYYY")}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <AppDialog edit app={row} />

                          <ToolTipButton
                            title="Delete"
                            placement="bottom"
                            onClick={() => handleDelete(row._id)}
                          >
                            <DeleteIcon color="error" />
                          </ToolTipButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </Fragment>
              ) : (
                <TableRow>
                  <TableCell colSpan="6" align="center">
                    <Typography variant="body2">Nothing to show!</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  length={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default React.memo(Category);
